import {TranslateService} from '@ngx-translate/core';

export function _TRANSLATE(src: string) {
  return src;
}
